export const LIST_SORACOM_SUBSCRIBERS = 'LIST_SORACOM_SUBSCRIBERS';
export const CLEAR_SORACOM_SUBSCRIBERS = 'CLEAR_SORACOM_SUBSCRIBERS';
